export const COUNTRY_CODE_USA = 'US';
export const COUNTRY_CODE_CANADA = 'CA';
export const COUNTRY_CODE_UK = 'UK';
export const COUNTRY_CODE_UK_GB = 'GB';
export const COUNTRY_CODE_FRENCH = 'FR';
export const COUNTRY_CODE_GERMANY = 'DE';
export const COUNTRY_CODE_ITALY = 'IT';
export const COUNTRY_CODE_TURKEY = 'TR';
export const COUNTRY_CODE_PORTUGAL = 'PT';
export const COUNTRY_CODE_SPAIN = 'ES';
export const COUNTRY_CODE_CHINA = 'CN';
export const COUNTRY_CODE_JAPAN = 'JP';
export const COUNTRY_CODE_KOREA = 'KR';
export const COUNTRY_CODE_MEXICO = 'MX';

export const COUNTRY_CODE_ALL = [
  COUNTRY_CODE_USA,
  COUNTRY_CODE_CANADA,
  COUNTRY_CODE_UK_GB,
  COUNTRY_CODE_SPAIN,
  COUNTRY_CODE_FRENCH,
  COUNTRY_CODE_GERMANY,
  COUNTRY_CODE_ITALY,
  COUNTRY_CODE_TURKEY,
  COUNTRY_CODE_PORTUGAL,
  COUNTRY_CODE_CHINA,
  COUNTRY_CODE_JAPAN,
  COUNTRY_CODE_KOREA,
  COUNTRY_CODE_MEXICO
];

const REGION_NA = 'NA';
const REGION_EU = 'EU';
const REGION_AS = 'AS';

const REGION_NA_STRING = 'languagePicker.geo.na';
const REGION_EU_STRING = 'languagePicker.geo.eu';
const REGION_AS_STRING = 'languagePicker.geo.as';

export const LOCALE_USA = 'en_us';
export const LOCALE_CANADA = 'en_ca';
export const LOCALE_MEXICO = 'es_la';
export const LOCALE_UK = 'en_gb';
export const LOCALE_UK_GB = 'en_gb';
export const LOCALE_SPAIN = 'es_es';
export const LOCALE_FRENCH = 'fr_fr';
export const LOCALE_GERMANY = 'de_de';
export const LOCALE_ITALY = 'it_it';
export const LOCALE_TURKEY = 'tr_tr';
export const LOCALE_PORTUGAL = 'pt_pt';
export const LOCALE_SIMPLIFIED_CHINESE = 'cn_cn';
export const LOCALE_TRADITIONAL_CHINESE = 'tc_cn';
export const LOCALE_JAPANESE = 'ja_ja';
export const LOCALE_KOREAN = 'ko_ko';

export const LOCALE_PRE = 'locale_pre';

export const COUNTRYCODE_STRING_MAP = {
  [`${COUNTRY_CODE_USA}`]: {
    name: 'languagePicker.country.usa',
    language: 'languagePicker.lang.english',
    locale: LOCALE_USA,
    region: REGION_NA_STRING
  },
  [`${COUNTRY_CODE_CANADA}`]: {
    name: 'languagePicker.country.canada',
    language: 'languagePicker.lang.english',
    locale: LOCALE_CANADA,
    region: REGION_NA_STRING
  },
  [`${COUNTRY_CODE_MEXICO}`]: {
    name: 'languagePicker.country.mexico',
    language: 'languagePicker.lang.spanish',
    locale: LOCALE_MEXICO,
    region: REGION_NA_STRING
  },
  [`${COUNTRY_CODE_UK}`]: {
    name: 'languagePicker.country.uk',
    language: 'languagePicker.lang.english',
    locale: LOCALE_UK,
    region: REGION_EU_STRING
  },
  [`${COUNTRY_CODE_UK_GB}`]: {
    name: 'languagePicker.country.uk',
    language: 'languagePicker.lang.english',
    locale: LOCALE_UK_GB,
    region: REGION_EU_STRING
  },
  [`${COUNTRY_CODE_SPAIN}`]: {
    name: 'languagePicker.country.spain',
    language: 'languagePicker.lang.spanish',
    locale: LOCALE_SPAIN,
    region: REGION_EU_STRING
  },
  [`${COUNTRY_CODE_FRENCH}`]: {
    name: 'languagePicker.country.france',
    language: 'languagePicker.lang.french',
    locale: LOCALE_FRENCH,
    region: REGION_EU_STRING
  },
  [`${COUNTRY_CODE_GERMANY}`]: {
    name: 'languagePicker.country.germany',
    language: 'languagePicker.lang.german',
    locale: LOCALE_GERMANY,
    region: REGION_EU_STRING
  },
  [`${COUNTRY_CODE_ITALY}`]: {
    name: 'languagePicker.country.italy',
    language: 'languagePicker.lang.italian',
    locale: LOCALE_ITALY,
    region: REGION_EU_STRING
  },
  [`${COUNTRY_CODE_TURKEY}`]: {
    name: 'languagePicker.country.turkey',
    language: 'languagePicker.lang.turkish',
    locale: LOCALE_TURKEY,
    region: REGION_EU_STRING
  },
  [`${COUNTRY_CODE_PORTUGAL}`]: {
    name: 'languagePicker.country.portugal',
    language: 'languagePicker.lang.portuguese',
    locale: LOCALE_PORTUGAL,
    region: REGION_EU_STRING
  },
  [`${COUNTRY_CODE_CHINA}`]: {
    name: 'languagePicker.country.china',
    language: 'languagePicker.lang.simplifiedChinese',
    secondLanguage: 'languagePicker.lang.traditionalChinese',
    locale: LOCALE_SIMPLIFIED_CHINESE,
    secondLocale: LOCALE_TRADITIONAL_CHINESE,
    region: REGION_AS_STRING
  },
  [`${COUNTRY_CODE_JAPAN}`]: {
    name: 'languagePicker.country.japan',
    language: 'languagePicker.lang.japanese',
    locale: LOCALE_JAPANESE,
    region: REGION_AS_STRING
  },
  [`${COUNTRY_CODE_KOREA}`]: {
    name: 'languagePicker.country.korea',
    language: 'languagePicker.lang.korean',
    locale: LOCALE_KOREAN,
    region: REGION_AS_STRING
  }
};

export const getNavigatorCountryCode = () =>
  (navigator && navigator.language && navigator.language.split('-')[1]) || COUNTRY_CODE_USA;

export const getLanguageFromLocale = locale => {
  if (!locale || typeof locale !== 'string') return COUNTRYCODE_STRING_MAP[COUNTRY_CODE_USA].language;
  if (locale.includes('cn')) {
    const chinaObj = COUNTRYCODE_STRING_MAP[COUNTRY_CODE_CHINA];
    return locale === chinaObj.locale ? chinaObj.language : chinaObj.secondLanguage;
  }
  return (
    COUNTRYCODE_STRING_MAP[COUNTRY_CODE_ALL.find(code => COUNTRYCODE_STRING_MAP[code].locale === locale)] ||
    COUNTRYCODE_STRING_MAP[COUNTRY_CODE_USA]
  ).language;
};

export const guessLocaleFromLanguage = language => {
  const filtered =
    COUNTRYCODE_STRING_MAP[
      COUNTRY_CODE_ALL.filter(code => COUNTRYCODE_STRING_MAP[code].locale.split('_')[0] === language)[0]
    ];
  return filtered ? filtered.locale || LOCALE_USA : LOCALE_USA;
};

// Language Picker Options
export const OPTIONS_REGION = [
  { key: REGION_NA, region: REGION_NA_STRING },
  { key: REGION_EU, region: REGION_EU_STRING },
  { key: REGION_AS, region: REGION_AS_STRING }
];
export const OPTIONS_LANGUAGE = COUNTRY_CODE_ALL.map(code => ({
  countryCode: code,
  locale: COUNTRYCODE_STRING_MAP[code].locale,
  language: COUNTRYCODE_STRING_MAP[code].language
}));

// Country Code Look-Ups
export const getCountryCodeName = code => COUNTRYCODE_STRING_MAP[code].name;
export const getCountryCodeRegion = code => COUNTRYCODE_STRING_MAP[code].region;
export const getCountryCodeLocale = code => COUNTRYCODE_STRING_MAP[code].locale;
export const getCountryCodeLanguage = code =>
  COUNTRYCODE_STRING_MAP[code] && COUNTRYCODE_STRING_MAP[code].language
    ? COUNTRYCODE_STRING_MAP[code].language
    : COUNTRYCODE_STRING_MAP[COUNTRY_CODE_USA].language;
